/* Native storefront Back. Reads browser entries only; never rewrites history or cart state. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else factory(root);
})(typeof window !== 'undefined' ? window : this, function (win) {
  'use strict';
  if (!win || !win.document) return;
  const link = win.document.getElementById('rudca-mobile-back');
  if (!link || link.dataset.rudcaBackInstalled === 'true') return;
  link.dataset.rudcaBackInstalled = 'true';
  const mobile = win.matchMedia('(max-width: 640px)');
  let pending = false;

  function sameOriginURL(value) {
    if (typeof value !== 'string' || !value.trim()) return null;
    try {
      const url = new URL(value, win.location.href);
      return url.origin === win.location.origin && /^https?:$/.test(url.protocol) ? url : null;
    } catch (_) { return null; }
  }
  // Liquid supplies the localized catalog route. An untrusted URL is never followed.
  const fallback = sameOriginURL(link.getAttribute('href')) || new URL('/collections/all', win.location.href);
  link.href = fallback.href;

  function usablePreviousEntry() {
    // Referrer + history.length cannot prove the preceding entry after replace/Back/Forward.
    // Older browsers therefore take the real catalog link rather than guessing.
    try {
      const navigation = win.navigation;
      const current = navigation && navigation.currentEntry;
      if (!current || !Number.isInteger(current.index) || current.index < 1 || !navigation.canGoBack) return false;
      const entries = navigation.entries();
      const previous = entries[current.index - 1];
      return !!(entries[current.index] && entries[current.index].key === current.key && previous && sameOriginURL(previous.url));
    } catch (_) { return false; }
  }

  function sync() {
    const unavailable = !usablePreviousEntry() && fallback.href === win.location.href;
    link.setAttribute('aria-disabled', String(pending || unavailable));
    if (pending) link.setAttribute('aria-busy', 'true');
    else link.removeAttribute('aria-busy');
  }
  function reset() { pending = false; sync(); }
  function openCatalog() {
    try { win.location.assign(fallback.href); }
    catch (_) { reset(); }
  }

  link.addEventListener('click', function (event) {
    if (!mobile.matches || event.defaultPrevented) return;
    if (pending || link.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
    if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    pending = true;
    sync();
    if (usablePreviousEntry()) {
      try { win.history.back(); }
      catch (_) { openCatalog(); }
    } else openCatalog();
  });
  link.addEventListener('auxclick', function (event) {
    if (mobile.matches && (pending || link.getAttribute('aria-disabled') === 'true')) event.preventDefault();
  });
  win.addEventListener('pageshow', reset);
  win.addEventListener('popstate', reset);
  if (win.navigation && typeof win.navigation.addEventListener === 'function') {
    win.navigation.addEventListener('navigateerror', reset);
    win.navigation.addEventListener('currententrychange', sync);
  }
  sync();
});
